// Action links removed — mobile uses AvailabilityBottomNav, desktop uses left nav sidebar.
export const featurePageMapping: { [key: string]: PageMapping } = {
	"/availability": {
		actions: [],
		buttons: [],
		icon: "aod",
		label: "Availability",
		labelKey: "nav.availability.module.label",
		nav: false,
		title: ""
	},
	"/availability/count": {
		actions: [],
		buttons: [],
		icon: "add",
		label: "Quick Count",
		labelKey: "nav.availability.count.label",
		nav: true,
		title: "Quick Count",
		titleKey: "nav.availability.count.title"
	},
	"/availability/history": {
		actions: [],
		buttons: [],
		icon: "history",
		label: "History",
		labelKey: "nav.availability.history.label",
		nav: true,
		title: "Activity History",
		titleKey: "nav.availability.history.title"
	},
	"/availability/shrink": {
		actions: [],
		buttons: [],
		icon: "trending_down",
		label: "Record Shrink",
		labelKey: "nav.availability.shrink.label",
		nav: false,
		title: "Record Shrink",
		titleKey: "nav.availability.shrink.title"
	}
};

export const flatPageMapping: { [key: string]: PageMapping } = {
	...featurePageMapping
};
